import React from "react";

import { Timeline } from "../vertical-progress-timeline";
import "../vertical-progress-timeline/style.css";
import {EventPaper} from "../sections/Events";
// import Logo from "../media/img/AEROSOC.svg";
import {Paper, Stack, Typography} from "@mui/material";
import RocketryButton from "./RocketryButton";
import rawEvents from "../events.json";


export default function MyTimeLine() {

    const events = rawEvents.map(e => ({
        ...e,
        start: new Date(e.start),
        end: new Date(e.end)
    })).sort((a, b) => a.start - b.start);



    return (
        <Paper
            elevation={12}
            sx={{
                padding: 3,
                borderRadius: 3,
                marginTop: 3,
                backgroundColor: (theme) => theme.palette.missionGold.cream,
                maxWidth: '100%',
                textAlign: "center"
            }}
        >
        {/*<div className="App" style={{height: '0%',  paddingInline: 10, padding: 2,  backgroundColor: "black",}} onClick={() => setStateClick(stateClick + 1)}>*/}
            {/* {stateClick} */}

            <br />
            <div
                style={{
                    textAlign: 'center',
                    backgroundColor: "none",
                    height: 50,
                    lineHeight: '50px',

                }}
            >
                <Typography variant="h4" component="h5" style={{backgroundColor: null}}>
                    <b>Upcoming Events</b>
                </Typography>
            </div>
            {/*<div className="container">*/}
            <Stack direction="column" spacing={1} className={"container"}>

                <Timeline className="my-vertical-progress">
                    {events.map(e => {
                        const dateStr = e.start.toLocaleDateString("en-UK", { month: "2-digit", day: "2-digit" });

                        return (

                            <EventPaper key={e.id} date={dateStr}>
                                {e.title}
                            </EventPaper>

                        );
                    })}
                    {/*<EventPaper date="11/16">Rocket Launch Workshop</EventPaper>*/}
                    {/*<EventPaper date="11/18">Rocket Launch Workshop</EventPaper>*/}
                    {/*<EventPaper date="11/23">*/}
                    {/*    Event 1*/}
                    {/*</EventPaper>*/}
                    {/*<EventPaper date="11/28">Event 2</EventPaper>*/}
                    {/*<EventPaper date="12/02">*/}
                    {/*    Event 3*/}
                    {/*</EventPaper>*/}

                </Timeline>

            {/*</div>*/}
                </Stack>

            <a href={"/events/"}>
            <RocketryButton>See full calendar</RocketryButton>
            </a>

        {/*</div>*/}
        </Paper>
    );
}
